import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../shared/constants';
import { getSMSTemplate } from '../../../shared/services';
const useGetSMSTemplateList = () => {
    return useQuery({
        queryKey: [QueryKeys.GetSMSTemplateList],
        queryFn: async () => {
            const response = await getSMSTemplate();
            return response.data;
        },
    });
};
export default useGetSMSTemplateList;
